import React, { useState, useContext } from "react";

import Login from "../login/login";
import Signup from "../login/Signup";
import { Account } from "../login/Account";
import Status from "../login/Status";

export const LoginPage = () => {
    return (
        <div>
            <Account>
                <Login />
                <Status />
            </Account>
        </div>
    );
};
